import { render, staticRenderFns } from "./MarcaProducto.vue?vue&type=template&id=55907150&scoped=true&"
import script from "./MarcaProducto.vue?vue&type=script&lang=js&"
export * from "./MarcaProducto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55907150",
  null
  
)

export default component.exports